import classNames from 'classnames';
import Button from 'components/generics/buttons/Button';
import classes from 'components/generics/forms/TradeForm/components/TradeFormConfirm/index.module.scss';
import React, { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  onConfirm?: () => void;
  amount?: number;
  redemptionSharesValidAmount?: number;
}

const DebtRedeemFormConfirm = ({
  className,
  amount,
  onConfirm,
  redemptionSharesValidAmount,
}: Props) => {
  return (
    <div className={classNames(classes.container, className)}>
      <Button
        className={classes.buyButton}
        disabled={
          amount === 0 || !amount || amount > (redemptionSharesValidAmount || 0)
        }
        onClick={onConfirm}
      >
        Continue
      </Button>
    </div>
  );
};

export default DebtRedeemFormConfirm;
